import { Box, Container, DialogActions, IconButton, InputBase } from "@mui/material";
import CardServices from '../cardServices';
import { useEffect, useState } from "react";
import api from '../../../services/api';
import RegisterAccess from '../../../utils/registerAccess';
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import MessageError from "../../../messages/messageError";
import LoadingShort from "../../../load/loadingShort";
import { useNavigate } from "react-router-dom";
import HeaderGestorConfigs from "../../../utils/headerGestorConfigs";
// import { useSelector } from 'react-redux';

interface MenuState {
  analise: number;
  chefeArea : number;
  directoraGeralAdjunta : number;
  chefeDepartamento: number;
  directorGeral: number;
  indeferido: number;
  controloQualidade: number;
  inspeccao: number;
}

type MenuProps = {
  styles: string,
  children?: React.ReactNode
}

export default function MenuFarmacovigilancia({ styles, children }: MenuProps) {

  // const user = useSelector(state => state.account.user);
  const navigate = useNavigate()
  const [search, setSearch] = useState("");
  const [messageError, setMessageError] = useState("");
  const [loadMenu, setLoadMenu] = useState<boolean>(true)
  const [load, setLoad] = useState<boolean>(false)
  const [menu, setMenu] = useState<MenuState>({
    analise: 0,
    chefeArea: 0,
    directoraGeralAdjunta: 0,
    chefeDepartamento: 0,
    directorGeral: 0,
    indeferido: 0,
    controloQualidade: 0,
    inspeccao: 0,
  })

  useEffect(() => {
    api.get(`/menu/farmacovigilancia`)
      .then(response => {
        setMenu(response.data);
      }).catch(error => {

      }).finally(() => setLoadMenu(false))

  }, [])

  const searchNotificacao = async (e: any) => {
    e.preventDefault();
    setMessageError('')
    setLoad(true);

    try {
      const response = await api.patch(`/farmaco-vigilancia/serach-by-number`, {
        numero: search,
        // status: status, //  
      });
      // console.log(response)
      navigate(`/admin/farmacovigilancia/view/notificacao/${response.data.farmacoVigilancia?._id}`)
    } catch (error) {
      // console.error(error);
      // setMessageError(error?.response?.data.message);
      setMessageError('Notificação não encontrada!');
    } finally {
      setLoad(false);
    }
  };

  return (
    <Container>
      <RegisterAccess page={'farmacovigilancia'} />
      {messageError && <MessageError message={messageError} />}

      <DialogActions sx={{ padding: 0 }}>
        <form
          onSubmit={searchNotificacao}
          style={{
            width: '30%',
            border: "1px solid #85287e",
            borderRadius: 10,
            display: "flex",
            // padding: 3,
            // flexWrap: "wrap",
            marginRight: 20,
            marginTop: 5,
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            // autoFocus
            type="number"
            placeholder="Procurar pelo  número de processo"
            inputProps={{ "aria-label": "Filtrar lista" }}
            onChange={(e) => setSearch(e.target.value)}
          />

          <IconButton type="submit" aria-label="search">
            {load ? <LoadingShort text={''} /> : <SearchOutlinedIcon />}
          </IconButton>
        </form>
      </DialogActions>


      <Box className={styles}>
        <CardServices funcao='Técnico' load={loadMenu} count={menu.analise} icone={'/icones/controleQualidade/solicitacoesAnalise.svg'} nomeService={'Em Análise'} link={'/admin/farmacovigilancia/notificacoes/Análise'} />
        {/* <CardServices load={loadMenu} count={menu.analisado} icone={'/icones/expediente/saida.svg'} nomeService={'Analisados'} link={'/admin/farmacovigilancia/notificacoes/Analisado'} /> */}
        <CardServices load={loadMenu} count={menu.indeferido} icone={'/icones/solictacoesReprovadas.svg'} nomeService={'Indeferidos'} link={'/admin/farmacovigilancia/notificacoes/Indeferido'} />
      </Box>

      <Box className={styles}>

        <CardServices funcao='Chefe de Área' load={loadMenu} count={menu.chefeArea} icone={'/icones/chefedaSeccao.svg'} nomeService={'Chefe de Área'} link={'/admin/farmacovigilancia/notificacoes/Chefe de Área'} />
        <CardServices funcao='Chefe de Departamento' load={loadMenu} count={menu.chefeDepartamento} icone={'/icones/chefeDepartamento.svg'} nomeService={'Chefe de Departamento'} link={'/admin/farmacovigilancia/notificacoes/Chefe de Departamento'} />
        <CardServices load={loadMenu} count={menu.directoraGeralAdjunta} icone={'/icones/chefedaSeccao.svg'} nomeService={'Directora Geral Adjunta Servicos Executivos'} link={'/admin/farmacovigilancia/notificacoes/Directora Geral Adjunta para os Serviços Executivos'} />
        <CardServices funcao='Director Geral' load={loadMenu} count={menu.directorGeral} icone={'/icones/diretoraGeral.svg'} nomeService={'Diretor(a) Geral'} link={'/admin/farmacovigilancia/notificacoes/Director Geral'} />
        {/* <CardServices funcao='' load={loadMenu} count={menu.} icone={'/icones/controleQualidade/certificadosAutorizacoes.svg'} nomeService={'Certificados Emitidos'} link={'/admin/farmacovigilancia/notificacoes/Aprovado'} /> */}
      </Box>

      <HeaderGestorConfigs title={'OUTRAS ÁREAS'} />
      <Box className={styles}>
        <CardServices load={loadMenu} count={menu.controloQualidade} icone={'/icones/expediente/entrada.svg'} nomeService={'Controlo de Qualidade'} link={'/admin/farmacovigilancia/notificacoes/Controlo de Qualidade'} />
        <CardServices load={loadMenu} count={menu.inspeccao} icone={'/icones/expediente/entrada.svg'} nomeService={'Inspecção'} link={'/admin/farmacovigilancia/notificacoes/Inspecção'} />
     
        {children}
      </Box>

    </Container>
  )
}

